import { PartialCarConfiguration } from '~/app/market-config/models/car-confi-market-configuration';

const q8: PartialCarConfiguration = {
	nextBestActions: [
		{
			description: 'Proefrit plannen',
			icon: '',
			labelText: 'Proefrit plannen',
			target: '_blank',
			trackingName: 'testdrive',
			url: 'https://q8e-tronproefrit.nl/',
		},
		{
			description: 'Leasen & offerte ',
			icon: 'dealer-request',
			labelText: 'Leasen & offerte ',
			target: '_blank',
			trackingName: 'online leasing',
			url: 'https://www.audi.nl/nl/web/nl/modellen/q8-e-tron/q8-e-tron/q8-e-tron-leasen.html',
		},
	],
};

const q8etron = {
	...q8,
};
const q8sbetron = {
	...q8,
};
const sq8etron = {
	...q8,
};
const sq8sbetron = {
	...q8,
};
export { q8etron, q8sbetron, sq8etron, sq8sbetron };
